export default {
  'template.create.fail.message': 'Failed to create template',
  'tranfer.form.on': 'Transfer on',
  'transfer.legend': 'single transfer',
  'transfers.add': 'Add Transfer',
  'transfers.amount': 'Amount',
  'transfers.approve.error': 'Some selected transfers are not eligible to approve.',
  'transfers.approve.fail.message': 'Transfer(s) Failed',
  'transfers.approve.header': 'Approve Transfers',
  'transfers.approve.message': 'You are approving the following transfers:',
  'transfers.approve.success.message': 'Your transaction(s) have been approved.',
  'transfers.confirm':
    'You are about to <%=action%><%=template ? "" : " a"%> <%=type%><%=template ? "" : " transfer"%>.',
  'transfers.confirm.bulk.delete': '<%=type%> will be deleted and will not be processed.',
  'transfers.confirm.delete':
    '<%= template ? "" : " A"%> <%=type%><%= template ? "" : " transfer"%> will be deleted and will not be processed.',
  'transfers.confirm.wantToProceed': 'Do you want to proceed?',
  'transfers.create.fail.message': 'Transfer(s) failed to complete.',
  'transfers.create.success.message': 'Transfer(s) Submitted!',
  'transfers.create.successWithScheduled.message': ' <%=num%> Scheduled.',
  'transfers.create.successWithNum.message': ' <%=num%> Successful.',
  'transfers.create.success.message.approval': 'Transfer Accepted and is awaiting your approval.',
  'transfers.create.success.message.otherApproval':
    "Transfer Initiated and is awaiting other's approval.",
  'transfers.create.scheduled.message': 'The Transfer has been scheduled.',
  'transfers.create.success.messageAccountSummary': 'Transfer has been added to a queue.',
  'transfers.create.recurringTemplate': 'Success! 1 new transfer template added.',
  'transfers.create.recurringTemplateRequiresApproval':
    "Success! 1 new recurring transfer template added and requires other's approval.",
  'transfers.create.recurring': 'Success! 1 new transfer added.',
  'transfers.create.recurringRequiresApproval':
    "Success! 1 new transfer added and requires other's approval.",
  'transfers.date': 'Transfer Date',
  'transfers.createTemplateTitle': 'Create New Template',
  'transfers.memo': 'Memo',
  'transfers.modify.success.message': 'Success! You have modified a <%=entryMethod%> Transfer.',
  'transfers.plural': 'Transfer(s)',
  'transfers.reject.error': 'Some selected transfers are not eligible to reject.',
  'transfers.reject.fail.message': 'Transfer(s) Failed',
  'transfers.reject.header': 'Reject Transfers',
  'transfers.reject.message': 'You are rejecting the following transfers:',
  'transfers.reject.success.message': 'Your transaction(s) have been rejected.',
  'transfers.request.amount': 'Amount',
  'transfers.request.from': 'From Account',
  'transfers.request.templateName': 'Template Name',
  'transfers.request.to': 'To Account',
  'transfers.saveAsLabel': 'Save as a Template',
  'transfers.templateName': 'Template Name',
  'transfers.additionalTransfers': 'Additional Transfers',
  'TRANSFER.MAX_DAILY_COUNT_EXCEEDED': 'Max daily count exceeded',
  'TRANSFER.NO_FUTURE_DATE_AVAILABLE': 'No future date available',
  'transfers.counter.numberOfAdditionalTransfers': 'Number of additional transfers',
  'transfers.counter.defaultHeaderText': 'Counter Header Text'
};
